/// <reference path="Definitions/google.maps.d.ts" />
/// <reference path="Definitions/underscore.d.ts" />

import * as $ajax from './_ajax'
import * as $helpers from './_helpers'
import * as $modal from './_modal'
import { propertyform as $propertyform, ownerform as $ownerform } from './search'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    tempFlagId: string
    onPropertySearch: boolean
    prefix: string
}

let options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    $helpers.partialPageInit($('.' + options.pageName + ''))

    $('.' + options.pagePrefix + '-flags .bcfla-label').click(function () {
        $(this).toggleClass('bcfla-label-unchecked')
        $(this).toggleClass('bcfla-checked')
    })

    $('.' + options.pagePrefix + '-btn-save').click(function () {
        var names = []
        var ids = []
        $('.' + options.pagePrefix + '-table-name').each(function () {
            var icon = $(this).attr('data-include') == '+' ? 'plus' : 'minus'
            names.push('<span class="fas fa-' + icon + '-circle"></span> ' + $(this).html())

            ids.push($(this).attr('data-include') + $(this).attr('data-id'))
        })

        console.log(names)
        console.log(ids)

        if (options.onPropertySearch) {
            $propertyform.setTempflagId(options.prefix, options.tempFlagId, names, ids)
        } else {
            $ownerform.setTempflagId(options.prefix, options.tempFlagId, names, ids)
        }

        $modal.hide()
    })

    $('.' + options.pagePrefix + '-btn-close').click($modal.hide)

    $('.' + options.pagePrefix + '-btn-include').click(function () {
        addFlags(true)
    })
    $('.' + options.pagePrefix + '-btn-exclude').click(function () {
        addFlags(false)
    })

    $('.' + options.pagePrefix + '-table-delete').click(function () {
        $modal.load('/Flag/SearchTempflagModal', { delete: $(this).attr('data-id'), propertysearch: options.onPropertySearch, prefix: options.prefix }, false, true, false)
    })

    function addFlags(add: boolean) {
        var vals = []
        $('.' + options.pagePrefix + '-flags .bcfla-checked').each(function () {
            vals.push($(this).attr('data-value'))
        })

        if (add) $modal.load('/Flag/SearchTempflagModal', { include: vals.join(','), propertysearch: options.onPropertySearch, prefix: options.prefix }, false, true, false)
        else $modal.load('/Flag/SearchTempflagModal', { exclude: vals.join(','), propertysearch: options.onPropertySearch, prefix: options.prefix }, false, true, false)

        $('.' + options.pagePrefix + '-flags .bcfla-label').addClass('bcfla-label-unchecked')
        $('.' + options.pagePrefix + '-flags .bcfla-label').removeClass('bcfla-checked')
    }
}
